{
    "Presence_Page_Title": "Présence",
    "Presence_SortBy_Title": "Trier par :",
    "Presence_SortBy_Options_FullName_ASC": "Nom complet (A-Z)",
    "Presence_SortBy_Options_FullName_DSC": "Nom complet (Z-A)",
    "Presence_Search_Title": "Recherche",
    "Presence_Filter_Title": "Plus de filtres",
    "Presence_MoreFilters_Title": "Filtrer par :",
    "Presence_MoreFilters_Options_Department": "Département",
    "Presence_MoreFilters_Options_Queue": "File d'attente",
    "Presence_Filter_Availability_All": "Tous",
    "Presence_Filter_Availability_Available": "Disponible",
    "Presence_Filter_Availability_Busy": "Occupé",
    "Presence_Filter_Availability_Away": "L'éloignement",
    "Presence_Filter_Availability_Offline": "Hors ligne",
    "Presence_Filter_Availability_OutOfOffice": "Absence de bureau",
    "Presence_Filter_Availability_DoNotDisturb": "Ne pas déranger",
    "Presence_Filter_Availability_BeRightBack": "Je reviens tout de suite",
    "Presence_Activity_Available_Title": "Disponible",
    "Presence_Activity_Away_Title": "L'éloignement",
    "Presence_Activity_BeRightBack_Title": "Je reviens tout de suite",
    "Presence_Activity_Busy_Title": "Occupé",
    "Presence_Activity_DoNotDisturb_Title": "Ne pas déranger",
    "Presence_Activity_InAcall_Title": "Dans un appel",
    "Presence_Activity_InAConferenceCall_Title": "Lors d'une conférence téléphonique",
    "Presence_Activity_Inactive_Title": "Inactif",
    "Presence_Activity_InAMeeting_Title": "En réunion",
    "Presence_Activity_Offline_Title": "Hors ligne",
    "Presence_Activity_OffWork_Title": "Hors travail",
    "Presence_Activity_OutOfOffice_Title": "Absence de bureau",
    "Presence_Activity_PresenceUnknown_Title": "Présence inconnue",
    "Presence_Activity_Presenting_Title": "Présentation",
    "Presence_Activity_UrgentInterruptionsOnly_Title": "Interruptions urgentes uniquement",
    "Presence_NoUsers": "Il n'y a pas d'utilisateurs disponibles pour votre filtre actuel",
    "NAME": "Presence",
    "Presence_Activity_InACall_Title": "Dans un appel",
    "Presence_SearchQuery_TooLong": "La recherche est trop longue"
}